import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DatesHelpersService } from '../../services/tools/dates-helpers.service';
import { HelpersService } from '../../services/tools/helpers.service';
import { SocioFondeadorService } from '../../services/socio-fondeador.service';
import { FondeadoresService } from '../../services/fondeadores.service';
declare var $;

@Component({
  selector: 'app-retirar-saldo-modal',
  templateUrl: './retirar-saldo-modal.component.html',
  styleUrls: ['./retirar-saldo-modal.component.scss']
})
export class RetirarSaldoModalComponent implements OnInit {
  
  public inversiones_fondeador : any [];
  public retirar_saldo : any = {};
  public socio : any = {};
  public fondeador : any = {};
  public errors:any = {};
  public isLoading: boolean = false;
  public fechaActual : string = "";
  //Para forma de pago
  public opcionValida: boolean = false;
  public esBanco: boolean = false;
  public esTarjeta: boolean = false;
  public esCLABE: boolean = false;

  constructor(
    private datesHelper : DatesHelpersService,
    private helperService: HelpersService,
    public socioFondeadorService: SocioFondeadorService,
    private fondeadoresService: FondeadoresService,
    public dialogRef: MatDialogRef<RetirarSaldoModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.retirar_saldo = this.socioFondeadorService.esquemaRetiroSaldo();
    let defaultDates = this.datesHelper.getMonthDate();
    this.fechaActual = defaultDates.fechaFin;

    //Agregamos datos por default
    this.retirar_saldo.fecha_retiro_saldo = this.fechaActual;
    this.retirar_saldo.idSocio = this.data.idSocio;
    //  this.incremento_saldo.idSocio = this.data.inversiones.id;
    this.obtenerSocioId(this.data.idSocio);
  }

  public close(){
    this.dialogRef.close({retiro:false})
  }

  public aceptar(){
    //Validar
    this.retirar_saldo.monto_saldo = Number(this.retirar_saldo.monto_saldo);
    this.errors = this.socioFondeadorService.validarRetiroSaldo(this.retirar_saldo);
    
    if (this.retirar_saldo.Extra==""){
      this.retirar_saldo.idEsquema=0;
    }
    if(!$.isEmptyObject(this.errors)){
      return false;
    }

    if(this.retirar_saldo.monto_saldo <= this.socio.saldo){
      if(!this.isLoading){
        this.isLoading = true;
        //Eliminamos el dato extra que tenemos
        delete this.retirar_saldo.Extra;
        this.registrarRetiroSaldo();
      }else{
        console.log("Esperando a que termine una acción");
      }
    }else{
      alert("No cuenta con saldo suficiente para retirar lo que desea");
      this.close();
    }

    
  }

  public validarMonto(){
    if(this.retirar_saldo.monto_saldo <= this.socio.saldo){

    }else{
      alert("No cuenta con saldo suficiente para retirar lo que desea");
    }
  }

  public registrarRetiroSaldo(){
    this.socioFondeadorService.registrarRetiroSaldo(this.retirar_saldo).subscribe(
      (response)=>
      {
        const datosRetiro = response.json();

       if (datosRetiro.success) {
         this.helperService.notification('Retiro de saldo pendiente', 'Se ha registrado el retiro de saldo, pendiente por aceptar', 'success');
         this.dialogRef.close({ retiro: true });
         //setTimeout(() => {window.location.reload()},3000);
         this.isLoading = false;
       }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);
        this.showServicesErrors(error.json().content);
        this.dialogRef.close({ retiro: false });
        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          this.dialogRef.close({ retiro: false });
        }
      }
    );
  }

  public obtenerSocioId(id:number){
    this.isLoading = true;
    this.socioFondeadorService.getSocioEspecifico(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        
        if(jsonResult.content){
          this.socio = jsonResult.content;
          console.log("Socio ID: ", this.socio);
          //Asignamos idFondeador
          this.retirar_saldo.idFondeador = this.socio.idFondeador;
          this.retirar_saldo.monto_saldo = this.socio.saldo;
          console.log("Esquema saldo: ", this.retirar_saldo);
          this.isLoading = false;

          this.obtFondeadorId(this.socio.idFondeador);
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Obtenemos información del fondeador
  public obtFondeadorId(id:number){
    this.isLoading = true;
    this.fondeadoresService.getFondeadorById(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.fondeador = jsonResult.content[0];
          console.log("Fondeador ID: ", this.fondeador);
          if(this.fondeador.deposito_fondos == "transferencia"){
            if(this.fondeador.tipo_clabe_tarjeta === "tarjeta"){
              this.esTarjeta = true;
              this.retirar_saldo.tipo_clabe_tarjeta = this.fondeador.tipo_clabe_tarjeta;
              this.retirar_saldo.num_clabe_tarjeta = this.fondeador.num_clabe_tarjeta;
            }else if(this.fondeador.tipo_clabe_tarjeta === "clabe"){
              this.esCLABE = true;
              this.retirar_saldo.tipo_clabe_tarjeta = this.fondeador.tipo_clabe_tarjeta;
              this.retirar_saldo.num_clabe_tarjeta = this.fondeador.num_clabe_tarjeta;
            }else{
              this.esTarjeta = false;
              this.esCLABE = false;
            }
          }else{
            this.esTarjeta = false;
            this.esCLABE = false;
          }
          this.isLoading = false;
        }

        this.getInversionesFondeador(this.fondeador.id);
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public changeFormaPago(){
    if(this.retirar_saldo.forma_pago == "transferencia" || this.retirar_saldo.forma_pago == "tarjeta"){
      this.opcionValida = true;
    }else if(this.retirar_saldo.forma_pago == "cheque" || this.retirar_saldo.forma_pago == "efectivo"){
      this.opcionValida = false;
      this.retirar_saldo.banco = null;
      this.retirar_saldo.tipo_clabe_tarjeta = null;
      this.retirar_saldo.num_clabe_tarjeta = null;
    }
  }
  public changeTipoRetiro (){
    if (this.retirar_saldo.Extra==""){
      this.retirar_saldo.idEsquema=0;
    }
  }
  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }

  public getInversionesFondeador(id){
    this.isLoading = true;
    this.fondeadoresService.getInversionesId(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.inversiones_fondeador = jsonResult.content;
        }
        console.log("Esquemas del fondeador",jsonResult.content);
        this.isLoading = false;
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/modulo-vista/retirar-saldo-modal/retirar-saldo-modal.component.ts